import { render } from "./ContactInput.vue?vue&type=template&id=353c71d6&scoped=true"
import script from "./ContactInput.vue?vue&type=script&lang=js"
export * from "./ContactInput.vue?vue&type=script&lang=js"

import "./ContactInput.vue?vue&type=style&index=0&id=353c71d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353c71d6"]])

export default __exports__